export default __webpack_public_path__ + "static/media/10_bees_selected.f211121f.png";